<section id="{{ renderMode }}">
  <header class="has-header-text">
    <h1 mat-dialog-title class="has-icon">
      @if (renderMode === 'web-app') {
        <i class="{{ getIcon(displayTerms.listEntityType) }} white "></i>
      }
      <!-- TODO: Call from OnInit only, not HTML - e.g. entityIcon -->
      <span class="dialog-title-text">Select {{ displayTerms.listEntityLabel | titlecase }} for the AwesomeDoc</span>
      <span class="template-name" [innerHTML]="data.templateName" [matTooltip]="data.templateName" matTooltipShowDelay="500"></span>
    </h1>
    <mat-icon
      class="close-dialog"
      fontIcon="close"
      (click)="onCancelClick()"
      [matTooltip]="'Cancel creating ' + data.templateName + ' AwesomeDoc'"
      matTooltipShowDelay="500"
    ></mat-icon>
  </header>
  <div mat-dialog-content>
    <h2 class="heading-underline">
      <i class="{{ getIcon(displayTerms.listEntityType) }}" [ngClass]="{ white: renderMode === 'chrome-extension' }"></i>
      <!-- TODO: Call from OnInit only, not HTML - e.g. entityIcon -->
      <span>{{ displayTerms.listEntityLabel | titlecase }} for {{ data.entity.name }}</span>
      @if (data.entity?.name) {
        <mat-icon
          fontIcon="autorenew"
          class="sync-icon"
          (click)="refreshFiles()"
          [matTooltip]="'Resync ' + displayTerms.listEntityLabel + ' with ' + data.entity.name"
          role="button"
          matTooltipShowDelay="500"
        ></mat-icon>
      }
    </h2>
    <main class="scrollable-container">
      @if (!showSpinner && entities.length === 0) {
        <div class="box-no-files-text placeholder-text">
          NO {{ displayTerms.listEntityLabel | uppercase }} AVAILABLE
        </div>
      }
      <app-kp-simple-table
        [items]="entities"
        [columnHeadings]="columnHeadings"
        [isLoading]="showSpinner"
        [selectableRows]="true"
        [skeletonRowClasses]="'big-row'"
        [skeletonRowInstances]="2"
        [tableClasses]="'hover-rows large-side-padding scrollable-container'"
        (rowClick)="itemRowClick($event)"
        >
      </app-kp-simple-table>
    </main>
  </div>
  <section mat-dialog-actions class="footer-btns">
    <button
      mat-button
      (click)="onCancelClick()"
      theme-style="nav"
      class="danger-btn-hover"
      [matTooltip]="'Cancel creating ' + data.templateName + ' AwesomeDoc'"
      matTooltipShowDelay="500"
      appRipple
      >
      CANCEL
    </button>
    <button
      mat-button
      (click)="onOkClick()"
      theme-style="nav"
      [matTooltip]="entitySelected ? 'Continue creating ' + data.templateName + ' AwesomeDoc' : 'Choose a file to continue'"
      [disabled]="!entitySelected"
      appRipple
      >
      CONTINUE
    </button>
  </section>
</section>
